<template>
  <TsCarousel :breakpoints="breakpoints">
    <Slide v-for="(item, index) in data" :key="item.code">
          <TsCard appendClass="bg-[#F3F4F6] text-left" no-shadow no-border>
            <TsRow>
              <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 24 24">
                <path fill="#f1c40f"
                      d="m7.325 18.923l1.24-5.313l-4.123-3.572l5.431-.47L12 4.557l2.127 5.01l5.43.47l-4.123 3.572l1.241 5.313L12 16.102z"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 24 24">
                <path fill="#f1c40f"
                      d="m7.325 18.923l1.24-5.313l-4.123-3.572l5.431-.47L12 4.557l2.127 5.01l5.43.47l-4.123 3.572l1.241 5.313L12 16.102z"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 24 24">
                <path fill="#f1c40f"
                      d="m7.325 18.923l1.24-5.313l-4.123-3.572l5.431-.47L12 4.557l2.127 5.01l5.43.47l-4.123 3.572l1.241 5.313L12 16.102z"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 24 24">
                <path fill="#f1c40f"
                      d="m7.325 18.923l1.24-5.313l-4.123-3.572l5.431-.47L12 4.557l2.127 5.01l5.43.47l-4.123 3.572l1.241 5.313L12 16.102z"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 24 24">
                <path fill="#d9d9d9"
                      d="m7.325 18.923l1.24-5.313l-4.123-3.572l5.431-.47L12 4.557l2.127 5.01l5.43.47l-4.123 3.572l1.241 5.313L12 16.102z"/>
              </svg>
            </TsRow>
            <TsTypography>{{ item.description }}</TsTypography>
            <TsDivider></TsDivider>
            <TsAvatar v-if="props.author" appendClass="font-semibold" size="lg"
                      :name="item.name"
                      :description="item.position"
                      :image="item.avatar"
                      :data-testid="
              props.dataTestid
                ? props.dataTestid + '-author-avatar'
                : 'card-author-avatar'
            "
            />

          </TsCard>
    </Slide>
  </TsCarousel>
</template>

<script setup lang="ts">
type Props = {
  data: object[];
  breakpoints: object;
};

const TsCarousel = defineAsyncComponent(
    () => import('~/components/organisms/TsCarousel.vue')
);

const TsCarouselSlide = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselSlide.vue')
);

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

const TsAvatar = defineAsyncComponent(
    () => import('~/components/molecules/TsAvatar.vue')
);

const props = withDefaults(defineProps<Props>(), {
  data: [
    {
      description: 'Lorem ipsum dolor sit amet consectetur. Pellentesque tristique integer ut ipsum aliquet.',
      name: 'Jonathan Wheatley',
      shortname: 'JW',
      position: 'Marketing Manager',
      avatar: ''
    },
    {
      description: 'Lorem ipsum dolor sit amet consectetur. Pellentesque tristique integer ut ipsum aliquet.',
      name: 'John Carter',
      shortname: 'JC',
      position: 'Senior Manager',
      avatar: ''
    },
    {
      description: 'Lorem ipsum dolor sit amet consectetur. Pellentesque tristique integer ut ipsum aliquet.',
      name: 'Jonathan Wheatly',
      shortname: 'JW',
      position: 'Marketing Manager',
      avatar: ''
    },
    {
      description: 'Lorem ipsum dolor sit amet consectetur. Pellentesque tristique integer ut ipsum aliquet.',
      name: 'John Carter',
      shortname: 'JC',
      position: 'Senior Manager',
      avartar: ''
    },
  ],
  breakpoints: {
    0: {
      itemsToShow: 1.1,
      snapAlign: "center",
      itemsToScroll: 1
    },
    640: {
      itemsToShow: 2,
      snapAlign: "start",
      itemsToScroll: 2
    },
    1024: {
      itemsToShow: 4,
      snapAlign: "start",
      itemsToScroll: 3
    }

  }
});
</script>